import React from "react";
import { motion } from "framer-motion";
import { AccountAvatarIcon, PlusIcon } from "./icons";
export default function CompleteSection({
  data,
  onGoToBirthday,
  selectedCountry,
  errorsFormSubmit,
}) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      // transition={{ duration: 1 }}
    >
      {errorsFormSubmit.length > 0 && (
        <div
          className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 rounded-md mb-2"
          role="alert"
        >
          <p className="font-bold">Error Occurred!</p>
          {errorsFormSubmit.map((err) => (
            <p>{err}</p>
          ))}
        </div>
      )}
      <div className="bg-white border-2 border-gray-300 p-6 rounded-md tracking-wide shadow-lg">
        <div id="header" className="flex items-center mb-4">
          {/* <img
            alt="avatar"
            className="w-20 rounded-full border-2 border-gray-300"
            src={data.image.preview}
          /> */}
          <div className="mx-auto w-28 h-28 border rounded-full relative bg-gray-100 mb-4 shadow-inset overflow-hidden">
            {data.image ? (
              <div
                className="bg"
                style={{
                  backgroundImage: `url('${data.image.preview}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  width: "auto",
                  height: "100%",
                }}
              ></div>
            ) : (
              <AccountAvatarIcon iconClasses="h-28 w-28 text-gray-300 rounded-full" />
            )}
          </div>
          <div id="header-text" className="leading-5 ml-6 sm">
            <h4 id="name" className="text-xl font-semibold flex items-center">
              <span>
                {data.firstName} {data.lastName}
              </span>
            </h4>
            <div className="mb-3">
              {data.birthMonth && data.birthDay ? (
                <span className="text-sm italic">
                  🎂{" "}
                  <span className="italic">
                    {data.birthMonth}({data.birthDay})
                  </span>
                </span>
              ) : (
                <span className="text-sm  flex items-center">
                  😓
                  <span className="italic mr-2">No birthday added</span>
                  <button
                    onClick={onGoToBirthday}
                    className="italic bg-greyOne text-xs rounded-md text-white flex items-center px-2"
                  >
                    <span className="mr-2">🎂</span>
                    <PlusIcon iconClasses="h-2 w-2 fill-current text-theme" />
                  </button>
                </span>
              )}
            </div>
            <div className="flex flex-col">
              <h5 id="job" className="font-semibold text-gray-400">
                {data.email}
              </h5>
              <h5 id="job" className="font-semibold text-gray-400">
                {selectedCountry.value} {data.phoneNumber}
              </h5>
            </div>
          </div>
        </div>
        <div id="quote">
          <div className="flex items-center">
            <p>Industry:</p>
            <p>{data.industry}</p>
          </div>
          <div className="flex items-center">
            <p>Package:</p>
            <p>{data.package}</p>
          </div>
          <div className="flex items-center">
            <p>Hobbies:</p>
            <p className="italic text-gray-600">
              {data.hobbies.join(",").toString()}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
